import { render } from "./SystemOperation.vue?vue&type=template&id=5f0b772e&scoped=true"
import script from "./SystemOperation.vue?vue&type=script&lang=js"
export * from "./SystemOperation.vue?vue&type=script&lang=js"

import "./SystemOperation.vue?vue&type=style&index=0&id=5f0b772e&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0b772e"]])

export default __exports__